// import React from 'react';
import { Howl } from 'howler';
// import droneFx from '../sounds/dronefx.mp3';


const Howling = new Howl({
      //  src: [droneFx]
     src: ["../sounds/dronefx.mp3"],
    //  loop: false,
    //  playing:false,
});

Howling.volume(.3);




  

  export default Howling 